import { UserCustomFilter } from 'core/utils/types/user-custom-filter.type';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { useMenuFiltersHandler } from './hooks/use-menu-filters-handler.hook';

export const useAppMenuHandle = () => {
    const { showConfirmDeleteFilterModal, showRenameFilterModal } = useMenuFiltersHandler();
    const [selected, setSelected] = useState<string>('operators');

    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { operatorId, deviceId, lotId, trainingProgramId, trainingStageId } = useParams();

    useEffect(() => {
        const operatorDetailsUrl = `/operators/${operatorId}`;
        const deviceDetailsUrl = `/devices/${deviceId}`;
        const lotDetailsUrl = `/lots/${lotId}`;
        const trainingDetailsUrl = `/trainings/${trainingProgramId}/stages/${trainingStageId}`;

        if ([operatorDetailsUrl, deviceDetailsUrl, lotDetailsUrl].includes(pathname)) {
            return;
        }

        if (pathname === trainingDetailsUrl) {
            setSelected('trainings');
            return;
        }

        setSelected(pathname.slice(1));
    }, [pathname, operatorId, deviceId, lotId, trainingProgramId, trainingStageId]);

    const navigationClick = (option: string) => {
        setSelected(option);
        navigate(option);
    };

    const handleShowConfirmDeleteFilterModal = <T,>(filter: UserCustomFilter<T>) => {
        showConfirmDeleteFilterModal(filter, selected, () => {
            navigationClick(filter.entity!.toLowerCase());
        });
    };

    const handleShowRenameFilterModal = <T,>(filter: UserCustomFilter<T>) => {
        showRenameFilterModal(filter);
    };

    return {
        selected,
        setSelected,
        navigationClick,
        handleShowConfirmDeleteFilterModal,
        handleShowRenameFilterModal,
    };
};
